"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var TextFormatting = _interopRequireWildcard(require("@/helpers/TextFormatting"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var _Captcha = _interopRequireDefault(require("@/components/Captcha"));
var _CommonLayout = _interopRequireDefault(require("./CommonLayout"));
var _ServerSelector = _interopRequireDefault(require("../ServerSelector"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const log = _Logger.default.namespace('CustomServer');
var _default = exports.default = {
  components: {
    Captcha: _Captcha.default,
    StartupLayout: _CommonLayout.default,
    ServerSelector: _ServerSelector.default
  },
  data() {
    return {
      nick: '',
      password: '',
      show_password_box: false,
      network: null,
      isFragment: false,
      showSelector: false,
      termsAccepted: false,
      presetSelected: 'custom',
      connectErrors: [],
      connection: Misc.getDefaultConnection()
    };
  },
  computed: {
    startupOptions() {
      return this.$state.getSetting('settings.startupOptions');
    },
    greetingText() {
      const greeting = this.startupOptions.greetingText;
      if (typeof greeting === 'string') {
        return greeting;
      }
      if (this.isFragment) {
        return this.$t('start_greeting');
      }
      return this.$t('customserver_where');
    },
    showTabs() {
      if (this.isFragment || this.presetSelected !== 'custom') {
        return false;
      }
      return this.startupOptions.enableTabs ?? true;
    },
    termsContent() {
      const terms = this.startupOptions.termsContent;
      return typeof terms === 'string' ? terms : '';
    },
    buttonText() {
      const greeting = this.startupOptions.buttonText;
      return typeof greeting === 'string' ? greeting : this.$t('connect');
    },
    footerText() {
      const footer = this.startupOptions.footerText;
      return typeof footer === 'string' ? footer : '';
    },
    isNickValid() {
      let nickPatternStr = this.$state.getSetting('settings.startupOptions.nick_format');
      let nickPattern = '';
      if (!nickPatternStr) {
        // Nicks cannot start with [0-9- ]
        // ? is not a valid nick character but we allow it as it gets replaced
        // with a number.
        nickPattern = /^[a-z_\\[\]{}^`|][a-z0-9_\-\\[\]{}^`|]*$/i;
      } else {
        // Support custom pattern matches. Eg. only '@example.com' may be allowed
        // on some IRCDs
        let pattern = '';
        let flags = '';
        if (nickPatternStr[0] === '/') {
          // Custom regex
          let pos = nickPatternStr.lastIndexOf('/');
          pattern = nickPatternStr.substring(1, pos);
          flags = nickPatternStr.substr(pos + 1);
        } else {
          // Basic contains rule
          pattern = _lodash.default.escapeRegExp(nickPatternStr);
          flags = 'i';
        }
        try {
          nickPattern = new RegExp(pattern, flags);
        } catch (error) {
          log.error('Nick format error: ' + error.message);
          return false;
        }
      }
      return this.nick.match(nickPattern);
    },
    readyToStart() {
      let ready = !!this.nick;
      if (!this.connection.server) {
        return false;
      }
      if (!this.isNickValid) {
        ready = false;
      }
      if (this.termsContent && !this.termsAccepted) {
        ready = false;
      }
      return ready;
    }
  },
  created() {
    const options = this.startupOptions;
    if (Misc.queryStringVal('nick')) {
      this.nick = Misc.queryStringVal('nick');
    } else {
      this.nick = options.nick;
    }
    this.nick = Misc.processNickRandomNumber(this.nick);
    if (options.bouncer) {
      this.connection.type = 'bnc';
    }
    let saveThisSessionsState = false;

    // If we have networks from a previous state, launch directly into it
    if (this.$state.networks.length > 0) {
      const network = this.$state.networks[0];
      this.$state.setActiveBuffer(network.id, network.serverBuffer().name);
      saveThisSessionsState = true;
      this.$emit('start');
    } else if (window.location.hash.slice(1)) {
      const fragment = decodeURIComponent(window.location.hash.slice(1));
      const connections = [];
      fragment.split(';').filter(serverStr => !!serverStr.trim()).forEach(serverStr => {
        const conn = Misc.parsePresetServer(serverStr);
        if (conn) {
          connections.push(conn);
        }
      });

      // If more than 1 connection string is given, skip the connection screen
      // and add them all right away.
      if (connections.length === 0) {
        saveThisSessionsState = true;
        this.applyDefaults();
      } else if (connections.length === 1) {
        saveThisSessionsState = false;
        this.isFragment = true;
        Object.assign(this.connection, connections[0]);
      } else if (connections.length > 1) {
        saveThisSessionsState = false;
        connections.forEach((conn, idx) => {
          let nick = options.nick;
          if (conn.params?.has('nick')) {
            nick = conn.params.get('nick');
          } else {
            nick = Misc.queryStringVal('nick') || nick;
          }
          nick = Misc.processNickRandomNumber(nick);
          const password = conn.password || '';
          const net = this.createNetwork(conn, nick, password);

          // Set the first server buffer active
          if (idx === 0) {
            this.$state.setActiveBuffer(net.id, net.serverBuffer().name);
          }
        });
        this.$emit('start');
      }
    } else {
      saveThisSessionsState = true;
      this.applyDefaults();
    }
    if (saveThisSessionsState) {
      this.$state.persistence.watchStateForChanges();
    }
  },
  methods: {
    readableStateError(err) {
      return Misc.networkErrorMessage(err);
    },
    createNetwork(conn, nick, password, netName) {
      const options = this.startupOptions;
      const net = this.$state.addNetwork(TextFormatting.t('network'), nick, {
        server: conn.server,
        port: conn.port,
        tls: conn.tls,
        direct: conn.direct,
        path: conn.path,
        password: password,
        encoding: (options.encoding || 'utf-8').trim(),
        gecos: options.gecos,
        username: options.username
      });
      if (conn.type === 'bnc') {
        // Bouncer mode uses server PASS
        net.connection.password = netName ? `${this.nick}/${netName}:${password}` : `${this.nick}:${password}`;
        net.password = '';
      } else {
        net.connection.password = '';
        net.password = password;
      }
      return net;
    },
    startUp() {
      const conn = this.connection;
      let netList = [];
      if (conn.type === 'irc') {
        this.network = this.createNetwork(conn, this.nick, this.password);

        // Only switch to the first channel we join if multiple are being joined
        let hasSwitchedActiveBuffer = false;
        let bufferObjs = Misc.extractBuffers(conn.channels);
        bufferObjs.forEach(bufferObj => {
          let newBuffer = this.$state.addBuffer(this.network.id, bufferObj.name);
          newBuffer.enabled = true;
          if (newBuffer && !hasSwitchedActiveBuffer) {
            this.$state.setActiveBuffer(this.network.id, newBuffer.name);
            hasSwitchedActiveBuffer = true;
          }
          if (bufferObj.key) {
            newBuffer.key = bufferObj.key;
          }
        });
        if (!hasSwitchedActiveBuffer) {
          this.$state.setActiveBuffer(this.network.id, this.network.serverBuffer().name);
        }
      } else {
        // conn.type === 'bnc'
        netList = conn.channels.split(',').filter(n => !!n).map(n => n.trim());
        this.network = this.createNetwork(conn, this.nick, this.password, netList.shift());
        this.$state.setActiveBuffer(this.network.id, this.network.serverBuffer().name);
      }
      this.network.ircClient.connect();
      let onRegistered = () => {
        if (this.$refs.layout) {
          this.$refs.layout.close();
        }
        this.network.ircClient.off('registered', onRegistered);
        this.network.ircClient.off('close', onClosed);
        this.network.ircClient.off('irc error', onError);
        netList.forEach(netName => {
          const net = this.createNetwork(conn, this.nick, this.password, netList.shift());
          net.ircClient.connect();
        });
      };
      let onClosed = () => {
        let lastError = this.network.last_error;
        if (lastError && !this.connectErrors.includes(lastError)) {
          this.connectErrors.push(lastError);
        }
        this.network.ircClient.off('registered', onRegistered);
        this.network.ircClient.off('close', onClosed);
        this.network.ircClient.off('irc error', onError);
      };
      let onError = event => {
        if (!event.reason || this.connectErrors.includes(event.reason)) {
          return;
        }
        this.connectErrors.push(event.reason);
      };
      this.network.ircClient.once('registered', onRegistered);
      this.network.ircClient.once('close', onClosed);
      this.network.ircClient.on('irc error', onError);
    },
    applyDefaults() {
      const options = this.startupOptions;
      this.showSelector = true;
      const port = options.port || 6697;
      Object.assign(this.connection, {
        server: options.server || '',
        port: port,
        tls: options.tls || port !== 6667,
        direct: options.direct || false,
        path: options.direct_path || '',
        type: options.bouncer ? 'bnc' : 'irc',
        channels: options.channel || ''
      });
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
if(!window._app_exports["components"]["startups"]) window._app_exports["components"]["startups"] = {};
window._app_exports["components"]["startups"]["CustomServer"]
window._app_exports.components.startups.CustomServer = exports.default ? exports.default : exports;
